module.exports = __webpack_public_path__ + "assets/img/block-hover-6c4d5fa1.png";